export const IneligibleAccountsContent = {
  buttonText: `View ineligible accounts`,
  modalHeader: `Ineligible accounts`,
  modalBodyFrom: `Below are your accounts that aren’t eligible to transfer from and the reasons why.`,
  modalBodyTo: `Below are your accounts that aren’t eligible to transfer to and the reasons why.`,
  reasons: {
    nonBrokerageAccount:
      '<a class="c11n-link c11n-link--secondary" href="https://personal1.vanguard.com/utb-upgrade-to-brokerage/explore/overview"><span class="c11n-link__content">Transition your mutual fund-only account</span></a> to our new platform:',
    primaryOwnerOnly: 'Only primary account owners can transfer investments using this process:',
    marginOrOptions: 'Accounts approved for Margin or Option trading are required to call in:',
    noBalance: `There's no balance available to transfer:`,
    personalAdvice: 'Consult your advisor before transferring to or from an advised account:',
    cashPlus:
      '<a class="c11n-link c11n-link--secondary" href="https://personal1.vanguard.com/awg-cash-transfer/transfer/select-type"><span class="c11n-link__content">Visit our cash experience</span></a> to transfer money out of your Cash Plus account or buy Vanguard money market funds:',
    accountType: `These accounts aren't eligible based on your previous account type selections:`,
    digitalAdvice: 'These accounts are enrolled in Digital Advisor:',
    nonMoneyMarketPositionSelected:
      'Cash plus accounts can only hold Vanguard Money Market funds\n(VMRXX, VMSXX, VYFXX, VUSXX, and VCTXX)',
    actrRestriction: 'This account can only hold Vanguard Mutual Funds',
    fromNonVcToVcIneligible: `The account you're transferring out of prevents transfers into Vanguard Charitable accounts:`,
    fromVcToNonVcIneligible: `The account you're transferring out of prevents transfers into personal accounts:`,
    noVCTransactAuthority: `You don't have transact authority on this Vanguard Charitable account:`,
    vcToggleOff: `Vanguard Charitable accounts can't be transferred online right now:`,
    nonVcToggleOff: `Only Vanguard Charitable organization accounts can be transferred online right now:`,
    ineligibleForOptionsTransfer: `This account can't hold options positions:`,
  },
  ok: 'Ok, got it',
};
